module.exports = __webpack_public_path__ + "img/electronic_electric_use.4d836518.svg";